import React from 'react';
import { SelectItem } from 'src/models/common/SelectItem';

interface IDropdown {
    label?: string;
    onChange?: (selectItem: SelectItem) => void;
    items?: SelectItem[];
    size?: 'small' | 'medium' | 'large';
    value?: number | string;
}

const Dropdown = (props: IDropdown) => {
    const onChange = (event: React.FormEvent<HTMLSelectElement>) => {
        if (props.onChange) {
            props.onChange(props.items.find((item: SelectItem) => item.id.toString() === event.currentTarget.value));
        }
    };

    return (
        <span className={`dlc-dropdown ${props.size || 'small'}`}>
            <select onChange={onChange} value={props.value}>
                {props.items &&
                    props.items.map((item: SelectItem, i: number) => {
                        if (item.id === 0) {
                            return (
                                <option key={`sep-${i}`} disabled={true}>
                                    ─────────────────────
                                </option>
                            );
                        } else {
                            return (
                                <option key={`opt-${i}`} style={{ padding: '2px 0' }} value={item.id}>
                                    {item.name}
                                </option>
                            );
                        }
                    })}
            </select>
        </span>
    );
};

export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/controls/Dropdown.tsx